/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./carousel/owl.carousel.min');
require('./scripts');
require('jquery-mousewheel');
require('./laravel_js/jquery.mCustomScrollbar.concat.min');


if ($("div").hasClass("scroll-div")) {
  scrollBody();
  window.addEventListener('resize', scrollBody);
}

$('.create-resume-5-minutes').on('click', function () {
  $(".scroll-div").mCustomScrollbar("scrollTo", $('#create-resume-5-minutes').position().top , {
    timeout: 0,
    scrollInertia: 400,
  });
})

function scrollBody() {
  if(window.innerWidth < 1025)
    $(".scroll-div").mCustomScrollbar('destroy');
  else{
    $(".scroll-div").mCustomScrollbar({
      axis: "y",
      scrollInertia: 500,
      mouseWheelPixels: 300
    });
  }
}






// WEBPACK FOOTER //
// ./resources/js/master.js